import React from "react";
import { VStack, HStack, Text, StackProps, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
interface TaskAdviceProps extends StackProps {
  instructions: string;
}

export const TaskAdvice = ({ instructions, ...rest }: TaskAdviceProps) => {
  const { t, i18n } = useTranslation();
  const localizedInstruction =
    i18n.language === "en" ? instructions[1] : i18n.language === "de" ? instructions[2] : instructions[0];

  return (
    <VStack w="full" minH="80px" pb="35px" justifyContent="center" align="stretch" {...rest}>
      <HStack align="start">
        <Text lineHeight="18px" fontSize="sm" fontWeight="bold" whiteSpace="nowrap">
          {t("Note_Text")}:
        </Text>
        <Box lineHeight="18px" fontSize="sm" dangerouslySetInnerHTML={{ __html: localizedInstruction }} />
      </HStack>
    </VStack>
  );
};
